import { memo, type PropsWithChildren } from "react";
import Box from "@mui/material/Box";

const InputGroup = ({ children }: PropsWithChildren) => (
    <Box
        sx={{
            alignSelf: 'flex-start',
            display: 'grid',
            gap: 1,
            minWidth: 0,
            '& .MuiFormControl-root': {
                width: '100%',
                minWidth: 0
            }
        }}
    >
        {children}
    </Box>
);

export default memo(InputGroup);
